import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Table } from 'react-bootstrap';
// import '../css/table.css';
import '../css/main.css';
import { authContext } from '../AzureAd';


export default class MaintenanceFixCardsComponent extends React.Component {
	operator = authContext.getCachedUser().userName;

	// constructor(props) {
	// 	super(props);
	// }

	previousPage() {
		//MaintenanceFixContainer
		hashHistory.push("/fixing");
	}

	componentDidMount() {
	}

	componentWillMount() {
		this.props.findFixableMCards(this.props.request.get('target'));
	}

	assignFixingPant(card) {
		this.props.assignFixingPant(card);
		hashHistory.push("/fixingTarget");
	}

	assignFixingClothes(card) {
		this.props.assignFixingClothes(card);
		hashHistory.push("/fixingTarget");
	}

	assignPreClothAction(card) {
		this.props.assignPreClothAction(card, this.operator);
	}

	assignPrePantAction(card) {
		this.props.assignPrePantAction(card, this.operator);
	}

	viewPhotos(cardId) {
		this.props.findPhotos(cardId);
		this.props.changePhotoListPreviousPage('/fixingCards');
		hashHistory.push("/photoList");
	}

	render() {

		let cardStatus = function (statusKey) {
			switch (statusKey) {

				case 'REFINED':
					return '待維修';
				//return '已確認';

				case 'FIXING':
					return '維修中';

				case 'FIXED':
					return '維修完成';

				case 'AUDITED':
					return '檢點完成';

				default:
					return "";
			}
		}

		let highlight = function (statusKey) {
			switch (statusKey) {
				case 'REFINED':
					return {
						textAlign: "center",
						backgroundColor: "#FFBFBF",
					};
				case 'FIXING':
					return {
						textAlign: "center",
						backgroundColor: "#FFE8BF",
					};
				case 'FIXED':
				case 'AUDITED':
					return {
						textAlign: "center",
						backgroundColor: "#96FF96",
					};
				default:
					return {};
			}
		}

		let highlightClassName = function (statusKey) {
			switch (statusKey) {
				case 'REFINED':
					return "highlight-red";
				case 'FIXING':
					return "highlight-brown";
				case 'FIXED':
				case 'AUDITED':
					return "highlight-green";
				default:
					return '';
			}
		}

		let sortIcon = (field) => {
			let orders = this.props.request.get('sortOrders');
			let asc = orders.get(field).get('asc');
			let icon;
			if (asc === undefined || orders.get('orderby') !== field) {
				icon = 'sort.svg';
			} else {
				icon = asc ? 'sort-up.svg' : 'sort-dw.svg';
			}

			return <a
				onClick={(event) => {
					this.props.sortCards(
						this.props.response.get('cards'),
						this.props.request.get('sortOrders').get(field));
				}
				}>
				<img src={icon} height="18" width="18" className='sort' alt="" />
			</a>
		}

		let alignCenter = {
			textAlign: "center",
			verticalAlign: "middle"
		}

		let disabledClothBtn = (card) => {
			return card.noClothes || card.discardClothes;
		}

		let disabledPreClothBtn = (card) => {
			return card.noClothes || card.discardClothes || card.clothPreprocedure;
		}

		let disabledPantBtn = (card) => {
			return card.noPant || card.discardPant;
		}

		let disabledPrePantBtn = (card) => {
			return card.noPant || card.discardPant || card.pantPreprocedure;
		}

		let clothBtnDesc = (card) => {
			let cloth = "";
			if (card.noClothes) {
				return cloth + "未送修";
			}
			if (card.discardClothes) {
				return cloth + "不需維修";
			}
			if (card.clothesFixed) {
				return cloth + "明細";
			}
			return "維修";
		}
		let pantBtnDesc = (card) => {
			let cloth = "";
			if (card.noPant) {
				return cloth + "未送修";
			}
			if (card.discardPant) {
				return cloth + "不需維修";
			}
			if (card.pantFixed) {
				return cloth + "明細";
			}
			return "維修";
		}

		let clothFixed = (card) => {
			if (card.noClothes || card.discardClothes) return "default";

			if (card.clothesFixed) {
				return "success"
			} else {
				return "warning"
			}
		}

		let pantFixed = (card) => {
			if (card.noPant || card.discardPant) return "default";
			if (card.pantFixed) {
				return "success"
			} else {
				return "warning"
			}
		}


		return (
			<div>
				<h4>
					維修作業&nbsp;&gt;&gt;&nbsp;維修卡&nbsp;
					<a onClick={(e) => { this.previousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
				</h4>
				<span hidden>MaintenanceFixCardsComponent </span>
				<table className="main">
					<tbody>
						<tr>
							<th width="14%">訂單編號</th>
							<td width="22%" className={"highlight"} style={{ textAlign: "center" }}>{this.props.request.get("mcase").orderId} {this.props.request.get("mcase").note}</td>
							<th width="14%">客戶名稱</th>
							<td width="22%">{this.props.request.get("mcase").customer.customerName}</td>
							<th width="14%">建立時間</th>
							<td width="14%">{new Date(this.props.request.get("mcase").createTime).toLocaleDateString()}</td>
						</tr>
					</tbody>
				</table>
				<br />
				<Table striped bordered condensed hover>
					<thead>
						<tr>
							<th>序號  {sortIcon("code")}</th>
							<th>單位 {sortIcon("unit")}</th>
							<th>使用者  {sortIcon("owner")}</th>
							<th>消防衣(維修)  {sortIcon("status")}</th>
							<th>消防褲(維修)  {sortIcon("status")}</th>
							<th>狀態  {sortIcon("status")}</th>
							<th>相片</th>
						</tr>
					</thead>
					<tbody>
						{
							this.props.response.get('cards').map(
								(item, index) =>
									<tr key={index}>
										<td>{item.code}</td>
										<td>{item.organization} - {item.unit}</td>
										<td>{item.owner}</td>
										<td>
											<Button bsStyle='info'
												disabled={disabledPreClothBtn(item)}
												onClick={(event) => {
													this.assignPreClothAction(item);
												}}
											>
												<img alt='shirt' src='shirt.svg' height="25" width="25" /> 前處理
											</Button>
											&nbsp;
											&nbsp;
											<Button bsStyle={clothFixed(item)}
												disabled={disabledClothBtn(item)}
												onClick={(event) => {
													this.assignFixingClothes(item);
												}}
											>
												<img alt='shirt' src='shirt.svg' height="25" width="25" /> {clothBtnDesc(item)}
											</Button>

										</td>
										<td>
											<Button bsStyle="info"
												disabled={disabledPrePantBtn(item)}
												onClick={(event) => {
													this.assignPrePantAction(item);
												}}
											>
												<img alt='shorts' src='shorts.svg' height="25" width="25" /> 前處理
											</Button>
											&nbsp;
											&nbsp;
											<Button bsStyle={pantFixed(item)}
												disabled={disabledPantBtn(item)}
												onClick={(event) => {
													this.assignFixingPant(item);
												}}
											>
												<img alt='shorts' src='shorts.svg' height="25" width="25" /> {pantBtnDesc(item)}
											</Button>

										</td>
										<td style={highlight(item.status)} className={highlightClassName(item.status)}>{cardStatus(item.status)}</td>
										<td style={alignCenter}>
											<Button onClick={(e) => { this.viewPhotos(item.id); }} >
												<img title="photos" alt='photos' src='gallery.svg' height="22" width="24" />
											</Button>
										</td>
									</tr>
							)
						}
					</tbody>
				</Table>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceFixCardsComponent.jsx